<template>
    <div>
        <v-server-table ref="clientTable" url="/clients/list" :columns="columns" :options="options">

            <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                <div class="clearfix d-md-none d-block"></div>

                <router-link :to="`/clients/create`" class="btn btn-success" title="Create a New Client"><i class="fa fa-plus-circle"></i> Create</router-link>

                <div class="clearfix d-sm-none d-block"></div>
            </div>

            <template slot="client_id" slot-scope="props">
                <router-link :to="`/clients/view/${props.row.client_id}`" title="View Client" class="btn btn-xs btn-secondary mr-1">
                    View
                </router-link>
                <router-link  :to="`/clients/edit/${props.row.client_id}`" title="Edit Client" class="btn btn-xs btn-light">
                    <i class="fa fa-edit"></i> Edit
                </router-link>
            </template>

            <router-link slot="client_name" slot-scope="props" :to="`/clients/view/${props.row.client_id}`" title="View Client">
                {{ props.row.client_name }}
            </router-link>

            <template slot="created_at" slot-scope="props">
                {{ props.row.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
            </template>

            <template slot="updated_at" slot-scope="props">
                {{ props.row.updated_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
            </template>

            <template slot="child_row" slot-scope="props">

                <label>Client Notes:</label><br/>
                {{ props.row.client_notes }}

            </template>

        </v-server-table>
    </div>
</template>

<script>
    export default {

        data: function() {
            return {
                userTimezone: this.$store.state.user.timezone,
                columns: ['client_id', 'client_name', 'contact_name', 'contact_phone', 'contact_email', 'client_address'],
                options: {
                    headings: {
                        client_id: 'Actions',
                        client_name: 'Name',
                        contact_name: 'Contact',
                        contact_phone: 'Phone',
                        contact_email: 'Email',
                        client_address: 'Address',
                        created_at: 'Created',
                        updated_at: 'Last Updated',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'clients.client_id',
                    },
                    requestAdapter: (data) => {
                        // //Parse the filters
                        // data.filters = {
                        //     'client.DivisionId': []
                        // };

                        // for(var i = 1; i <= this.$store.state.tableFilters.clientFilters['client.DivisionId'].length; i++)
                        // {
                        //     //Add each id
                        //     data.filters['client.DivisionId'].push(this.$store.state.tableFilters.clientFilters['client.DivisionId'][(i - 1)]['id']);
                        // }

                        // //INclude the asset
                        // data.assetType = this.assetType
                        // data.assetId = this.assetId

                        //Send it
                        return data;
                    },
                    uniqueKey: 'client_id',
                },
            }
        },

        methods: {

            filtersChanged: function (filters) {
                //Set the store
                this.$store.commit('setFilters', {key: 'clientFilters', filters: filters});

                //Set the data
                this.$refs.clientTable.getData();
            },

            filtersCleared: function (filters) {
                this.$store.commit('setFilters', {key: 'clientFilters', filters: {
                    'client.DivisionId': [],
                }});

                this.$refs.clientTable.refresh();
            },
        },
    }
</script>
